// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:17:03+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            098465ba842e1b1d4458d294031fde4b
//    Signature:      eyJpdiI6IjJpXC9JdWd2amlCVHhqYSt4UlVYbmhnPT0iLCJ2YWx1ZSI6IkQ1amVSOGhwZG1mMU1NSGlEendLb3ZcL2JvQjk5OTkrV3U2Y3VkTGZPdHFlemFFXC91U1Q0OXBOSTJyYmdkV1BGSTY0SWsxazlSVEtYS05oRDRCelA4bnFGSXpHb1pMcVNsNWw1dUl3aEYyU3BvMTZYSEdYMmo2Qk5uOU1PajhwQnB2cG12akt6VUhqXC9jb0pwbmZzV0dXR3VZKzIwejZnTFF0SU0wT2RVVm4rMmorNzVud0t4V0tJRWRwcnc4WUxocDE3Rlk4SFdaTW41cEhHbHBSRlRnVTZrd3VXYTE5RnViOFRDU21vdjFEXC9YTGl0MXFCQ05iaDdSblVVQXRNcitmcjB2MWdYSlo5dGhpTXBZb2lmWW5UUHQ4YmhDWGpjQXl6bjhXeEZDK3pIc01QV3NRbGZqK1hmOEs4azBjR21FUUFQc0FWWndGc1RqclRHZjBDY0ZLckl4bzBcL093NXpxRThXOWg2K2t4TStYQVBlXC9iQUtsTnBaYnV1VzFOM25lQTI5VEhNcWNERm1BTVdQY2dpeEpXNGc9PSIsIm1hYyI6ImYyNmJmMTM4OTRkNmRlZDEyZjczMDY3ZDY3NmQ0MjkzYTYwMjAyMGZkYWNiZTg5MmQzYzU5YzJiNTJkOWZlYjQifQ==
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
